<template>
  <div
    v-if="$login.can('subscriptions.create')"
    class="subscriptions-create"
  >
    <page-header header="Subscriptions">
      <button
        v-loading="loading"
        class="ml-1 btn btn-outline-secondary "
        type="button"
        @click="$router.go(-1)"
      >
        <loading-button-icon
          :loading="loading"
          class="mr-1"
          icon="arrow-left"
        />
        Back
      </button>
      <button
        v-loading="loading"
        class="ml-1 btn btn-primary "
        type="button"
        @click="$refs.form.save()"
      >
        <loading-button-icon
          :loading="loading"
          class="mr-1"
          icon="save"
        />
        Save
      </button>
    </page-header>

    <subscription-form
      ref="form"
      :account="acct"
      class="mt-3 mx-3"
      @save-success="createSuccess"
    />
  </div>
</template>

<script>
import SubscriptionForm from './Form'
import axios from '@/axios'
import {successNotification} from '@/notifications'

const getAccount = (id, cb) => {
  axios.get('/accounts/' + id).then((response) => {
    cb(null, response.data)
  })
}

export default {
  metaInfo () {
    return {
      title: 'Create Subscription',
    }
  },

  components: {
    SubscriptionForm,
  },

  props: {
    account: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data () {
    return {
      loading: false,
      acct: null,
    }
  },

  beforeMount () {
    this.acct = this.account
  },

  beforeRouteEnter (to, from, next) {
    if (!to.query.account_id) {
      return next()
    }

    getAccount(to.query.account_id, (err, data) => {
      next((vm) => vm.setAccount(err, data))
    })
  },

  beforeRouteUpdate (to, from, next) {
    if (!to.query.account_id) {
      return next()
    }

    getAccount(to.query.account_id, (err, data) => {
      this.setAccount(err, data)
      next()
    })
  },

  methods: {
    setAccount (erer, data) {
      this.acct = data.data
    },

    createSuccess (response) {
      this.$notify(successNotification('Created successfully'))
      this.$router.replace({name: 'subscriptions.view', params: {subscriptionId: response.data.data.id}})
    },
  },
}
</script>
